import Vue from 'vue'
import Router from 'vue-router'
let ucenterIndex = resolve => require.ensure([], () => resolve(require('../components/ucenter/index/index.vue')), 'ucenterIndex');
let personal = resolve => require.ensure([], () => resolve(require('../components/ucenter/personal/index.vue')), 'personal');
let phoneBind = resolve => require.ensure([], () => resolve(require('../components/ucenter/security/phoneBind/phoneBind.vue')), 'phoneBind');
let userLevel = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/userLevel/userLevel.vue')), 'userLevel');
let wallet = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/wallet/wallet.vue')), 'wallet');
let integral = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/integral/integral.vue')), 'integral');
let integraLmore = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/integral/more/more.vue')), 'integraLmore');
let voucher = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/voucher/voucher.vue')), 'voucher');
let smallChange = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/smallChange/smallChange.vue')), 'smallChange');
let recharge = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/recharge/recharge.vue')), 'recharge');
let invoice = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/invoice/index.vue')), 'invoice');
let apply = resolve => require.ensure([], () => resolve(require('../components/ucenter/account/invoice/apply/apply.vue')), 'apply');
let join = resolve => require.ensure([], () => resolve(require('../components/ucenter/basic/join/join.vue')), 'join');
let problem = resolve => require.ensure([], () => resolve(require('../components/ucenter/basic/problem/problem')), 'problem');
let passport = resolve => require.ensure([], () => resolve(require('../components/ucenter/security/login/passport.vue')), 'passport');
let index = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/index/index.vue')), 'index');
let userOrder = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/userOrder/index/index.vue')), 'userOrder');
let orderDetails = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/userOrder/orderDetails/orderDetails.vue')), 'orderDetails');
let teaIndex = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/tea/index/index.vue')), 'teaIndex');
let details = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/tea/details/details.vue')), 'details');
let addressPosition = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/tea/details/addressPosition.vue')), 'addressPosition');
let settlement = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/tea/settlement/settlement.vue')), 'settlement');
let orderPay = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/tea/settlement/orderPay/orderPay.vue')), 'orderPay');
let manual = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/basic/manual/manual')), 'manual');
let search = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/search/search.vue')), 'search');
let searchAddress = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/index/searchAddress.vue')), 'searchAddress');
let searchBlur = resolve => require.ensure([], () => resolve(require('../components/yw_liucha2/index/searchBlur.vue')), 'searchBlur');


import store from '../store/store.js'
import * as types from '../store/type.js'

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
  }, {
    path: '/searchBlur',
    name: 'searchBlur',
    component: searchBlur,
  },
  {
    path: '/passport/ucenter/login',
    name: 'passport',
    component: passport,
  },
  {
    path: '/ucenter/security/phoneBind/phoneBind',
    name: 'phoneBind',
    component: phoneBind
  },
  {
    path: '/ucenter/basic/problem/problem',
    name: 'problem',
    component: problem
  },
  {
    path: '/yw_liucha2/basic/manual/manual',
    name: 'manual',
    component: manual
  },
  {
    path: '/yw_liucha2/userOrder/orderDetails/orderDetails',
    name: 'orderDetails',
    component: orderDetails,
  },
  {
    path: '/yw_liucha2/userOrder/index/index',
    name: 'userOrder',
    component: userOrder
  },
  {
    path: '/yw_liucha2/tea/settlement/orderPay/orderPay',
    name: 'orderPay',
    component: orderPay
  },
  {
    path: '/yw_liucha2/tea/settlement/settlement',
    name: 'settlement',
    component: settlement
  },
  {
    path: '/yw_liucha2/tea/details/details',
    name: 'details',
    component: details
  },
  {
    path: '/yw_liucha2/tea/details/addressPosition',
    name: 'addressPosition',
    component: addressPosition
  },
  {
    path: '/yw_liucha2/tea/index/index',
    name: 'teaIndex',
    component: teaIndex
  },
  {
    path: '/yw_liucha2/search/search',
    name: 'search',
    component: search
  },
  {
    path: '/yw_liucha2/index/searchAddress',
    name: 'searchAddress',
    component: searchAddress
  },
  {
    path: '/ucenter/index/index',
    name: 'ucenterIndex',
    meta: {
        requireAuth: true,
    },
    component: ucenterIndex,
  },
  {
    path: '/ucenter/personal/index',
    name: 'personal',
    component: personal
  },
  {
    path: '/ucenter/account/userLevel/userLevel',
    name: 'userLevel',
    component: userLevel
  },
  {
    path: '/ucenter/account/wallet/wallet',
    name: 'wallet',
    component: wallet
  },
  {
    path: '/ucenter/account/integral/integral',
    name: 'integral',
    component: integral
  },
  {
    path: '/ucenter/account/integral/more/more',
    name: 'integraLmore',
    component: integraLmore
  },
  {
    path: '/ucenter/account/voucher/voucher',
    name: 'voucher',
    component: voucher
  },
  {
    path: '/ucenter/account/smallChange/smallChange',
    name: 'smallChange',
    component: smallChange
  },
  {
    path: '/ucenter/basic/join/join',
    name: 'join',
    component: join
  },
  {
    path: '/ucenter/account/recharge/recharge',
    name: 'recharge',
    component: recharge
  },
  {
    path: '/ucenter/account/invoice/index',
    name: 'invoice',
    component: invoice,
  },
  {
    path: '/ucenter/account/invoice/index/apply/',
    name: '/ucenter/account/invoice/index/apply',
    component: apply
  }
];

const router = new Router({
  routes
});

if (window.localStorage.getItem('token')) {
  store.commit(types.LOGIN, window.localStorage.getItem('token'))
}
router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.requireAuth)) {
    if (store.state.token) {
      if(to.name === 'passport'){
          this.$router.replace({ path:'/',});
      }else{
          next();
      }
    }
    else {
      next({
        path: '/passport/ucenter/login',
        query: {redirect: to.fullPath}
      })
    }
  }
  else {
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js